import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CalendlyLink } from '../calendlyLink.slice'
import { NormalizedSchema } from 'normalizr'

export type UserCallStateOfEvent =
  | 'completed'
  | 'missed'
  | 'skipped'
  | 'upcoming'
  | 'unscheduled'
  | 'not_required'
  | null

export type UserCallEventType =
  | 'onboarding'
  | 'other'
  | 'checkins'
  | 'connect_and_clarify'

export interface UserCallEvent {
  id: number
  userId: number
  callName: string
  location: string
  startTime: string | null
  endTime: string | null
  calendlyInviteeUuid: string
  rescheduleUuid: string | null
  calendlyEventId: string
  calendlyEvent: string
  canceledAt: string
  createdAt: string
  updatedAt: string
  adminCalendlyLinkId?: number
  skippedAt: string | null
  missedOn: string | null
  year: string | null
  quarter: '1' | '2' | '3' | '4' | null
  eventType: UserCallEventType | null
  eventState: UserCallStateOfEvent
  adminCalendlyLink: number
}

export interface UserCallEventEntities {
  userCallEvents?: { [key: number]: UserCallEvent }
  adminCalendlyLink?: { [key: number]: CalendlyLink }
}
export type NormalizedUserCallEvent = NormalizedSchema<
  UserCallEventEntities,
  number[] | number
>

export interface UserCallEventState {
  [key: number]: UserCallEvent
}

const initialState: UserCallEventState = {}

const userCallEventsSlice = createSlice({
  name: 'userCallEvents',
  initialState,
  reducers: {
    // Replace rather than merge: the fetch returns the full authoritative set
    // of the user's non-canceled events, so merging would leave a stale copy of
    // an event that was canceled server-side (e.g. the old slot after a
    // reschedule) lingering in state and being re-selected.
    receiveUserCallEvents: (
      _state,
      action: PayloadAction<NormalizedUserCallEvent>
    ) => action.payload.entities.userCallEvents ?? {},
  },
})

export default userCallEventsSlice.reducer

export const { receiveUserCallEvents } = userCallEventsSlice.actions
